import React from "react";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import Dialog from "../components/Dialog";
import withAuthorization from "../firebase/withAuthorization";
import {
  listActivities,
  listUsers,
  getProject,
  getClient
} from "../firebase/firestore";
import withAccount from "../utils/withAccount";
import TitleBar from "../components/TitleBar";
import IconButton from "../components/IconButton";
import { getUserAvatarUrl } from "../firebase/storage";
import { dateToTimeString, dateToStringShort } from "../utils/DateHelper";

class PageActivities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userFilter: null,
      showFilterPopup: false,
      activities: [],
      users: []
    };

    this.refFilterSelect = React.createRef();
  }

  fetchActivities(filter) {
    const { account } = this.props;

    this.setState({ isLoading: true });

    listActivities(account.id, filter, docs => {
      let activities = [];
      docs.forEach(element => {
        activities.push(element);
      });

      this.setState({ activities: activities, isLoading: false });
    });
  }

  componentDidMount() {
    const { account } = this.props;

    this.fetchActivities();

    listUsers(
      account.id,
      docs => {
        let users = [];
        docs.forEach(element => {
          const data = element.data();
          users.push({
            id: element.id,
            name: `${data.first} ${data.last}`
          });
        });
        this.setState({ users: users });
      },
      error => {
        console.log(error);
        this.setState({ users: [] });
      }
    );
  }

  applyFilter() {
    const filterUserId = this.refFilterSelect.current.value;

    if (filterUserId === "none") {
      this.setState({ userFilter: undefined });
      this.fetchActivities(undefined);
    } else {
      this.setState({ userFilter: filterUserId });
      this.fetchActivities(filterUserId);
    }

    this.toggleFilterPopup();
  }

  toggleFilterPopup() {
    const { showFilterPopup } = this.state;
    this.setState({ showFilterPopup: !showFilterPopup });
  }

  render() {
    const { account, history } = this.props;
    const { activities, showFilterPopup, users, userFilter } = this.state;

    let lastDate = null;
    const activityItems = activities.map(value => {
      const curDateString = dateToStringShort(value.data().timestamp.toDate());

      let addDateTitle = false;
      if (curDateString !== lastDate) {
        addDateTitle = true;
        lastDate = curDateString;
      }

      return (
        <div key={value.id}>
          {addDateTitle ? <TitleBar title={curDateString} small /> : null}
          {getActivityItemForActivity(account, value, history)}
        </div>
      );
    });

    const filterSelectUsers = users.map(value => (
      <option key={value.id} value={value.id}>
        {value.name}
      </option>
    ));

    //Get Name of currently selected user
    let filterUserName = "";
    for (let i = 0; i < users.length; i++) {
      if (users[i].id === userFilter) {
        filterUserName = users[i].name;
        break;
      }
    }

    return (
      <div>
        <Header
          title="Aktivitäten"
          showProjectsDropdown={false}
          showProfile={true}
          history={this.props.history}
        />
        <NavigationSideBar page="activities" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title={filterUserName} small>
            <IconButton
              icon="filter"
              onClick={() => this.toggleFilterPopup()}
            />
          </TitleBar>
          {activityItems}
        </InnerBody>

        <Dialog
          title="Nutzerfilter"
          visible={showFilterPopup}
          action="Filter Anwenden"
          onClose={() => this.toggleFilterPopup()}
          onAccept={() => this.applyFilter()}
        >
          <p>
            Lassen Sie sich nur die aktivitäten eines bestimmten Nutzers
            anzeigen
          </p>
          <select ref={this.refFilterSelect}>
            <option value="none">Keinen Filter</option>
            {filterSelectUsers}
          </select>
        </Dialog>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageActivities));

function getActivityItemForActivity(account, activity, history) {
  const { user, type, data, timestamp } = activity.data();
  const lut = ActivitiesLUT[type];
  return (
    <ActivityItem
      account={account}
      user={user}
      content={lut.text}
      data={data}
      displayType={lut.displayType}
      icon={lut.icon}
      time={timestamp}
      history={history}
    />
  );
}

class ActivityItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data_project_name: "",
      userAvatar: null,
      loadedClient: false,
      loadedProject: false,
      loadedUserAvatar: false
    };
  }

  componentWillMount() {
    this.setup();
    this.fetchContent();
  }

  setup() {
    const { displayType, icon } = this.props;
    let modeIcon, color;

    switch (displayType) {
      case "add":
        modeIcon = "fas fa-plus";
        color = "good";
        break;
      case "change":
        modeIcon = "fas fa-exchange-alt";
        color = "ap-action";
        break;
      case "deploy":
        modeIcon = "fas fa-rocket";
        color = "attention";
        break;
      case "remove":
        modeIcon = "fas fa-times";
        color = "bad";
        break;
      case "delete":
        modeIcon = "fas fa-trash";
        color = "bad";
        break;
      default:
        return null;
    }

    this.setState({ icon: icon, modeIcon: modeIcon, color: color });
  }

  fetchContent() {
    const { account, content, data, user } = this.props;

    if (content.includes("$PROJECT$")) {
      this.dataToLoad++;
      getProject(
        account.id,
        data.project,
        project => {
          this.setState({
            data_project_name: project.data().name,
            loadedProject: true
          });
          this.dataToLoad--;
        },
        error => {}
      );
    }

    if (content.includes("$CLIENT$")) {
      getClient(
        account.id,
        data.client,
        client => {
          this.setState({
            data_client_name: client.data().name,
            loadedClient: true
          });
        },
        error => {}
      );
    }

    getUserAvatarUrl(user, url => {
      this.setState({ userAvatar: url, loadedUserAvatar: true });
    });
  }

  render() {
    const { content, history, time } = this.props;
    const {
      icon,
      modeIcon,
      color,
      data_project_name,
      data_client_name,
      userAvatar,
      loadedClient,
      loadedUserAvatar,
      loadedProject
    } = this.state;

    let text = content;
    text = text.replace("$PROJECT$", data_project_name);
    text = text.replace("$CLIENT$", data_client_name);

    const ready = loadedClient && loadedProject && loadedUserAvatar;

    const timeString = dateToTimeString(time.toDate());

    return (
      <div className={`ActivityItem${ready ? "" : " ActivityItemHide"}`}>
        <div className="ActivityItemPanel">
          <div
            className="ActivityItemPanelIcon"
            style={{ backgroundColor: `var(--color-${color})` }}
          >
            <i id="Icon" className={icon} />
            <i id="Mode" className={modeIcon} />
          </div>
          {ready ? (
            <span>
              <p>{text}</p>
              <p className="ActivityItemPanelTime">{timeString}</p>
            </span>
          ) : (
            <i
              className="fas fa-spinner"
              style={{
                position: "absolute",
                width: "100%",
                fontSize: "20px",
                textAlign: "center",
                animation: "a 2s infinite linear"
              }}
            />
          )}
        </div>
        <img src={userAvatar} onClick={() => history.push("/dash/users")} />
      </div>
    );
  }
}

const ActivitiesLUT = {
  account_created: { text: "Hallo Welt", displayType: "add" },
  account_closed: { text: "Hallo Welt", displayType: "remove" },
  project_created: {
    text: "Das Projekt $PROJECT$ wurde für den Kunden $CLIENT$ erstellt.",
    icon: "fas fa-shapes",
    displayType: "add"
  },
  project_document_added: {
    text: "Dem Projekt $PROJECT$ wurde die Datei $FILE$ hinzugefügt.",
    icon: "fas fa-shapes",
    displayType: "add"
  },
  project_document_removed: {
    text: "Die Datei $FILE$ wurde aus dem Projekt $PROJECT$ entfernt.",
    icon: "fas fa-shapes",
    displayType: "delete"
  },
  project_deployed: {
    text: "Das Projekt $PROJECT$ wurde dem Kunden $CLIENT$ geschickt.",
    icon: "fas fa-shapes",
    displayType: "deploy"
  },
  project_closed: {
    text: "Hallo Welt",
    displayType: "remove",
    icon: "fas fa-shapes"
  },
  client_created: { text: "Hallo Welt", displayType: "add" },
  client_changed: { text: "Hallo Welt", displayType: "change" },
  client_deleted: { text: "Hallo Welt", displayType: "delete" },
  user_added: { text: "Hallo Welt", displayType: "add" },
  user_removed: { text: "Hallo Welt", displayType: "remove" },
  admin_migrated: { text: "Hallo Welt", displayType: "change" }
};



// WEBPACK FOOTER //
// ./src/pages/PageActivities.js